(function ($) {
    $.noConflict();
       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });
    $(document).ready(function () {

      // Back to Top Button
        let backToTop2 = $("#backToTop");
        if ($(window).scrollTop() > 300) { 
            backToTop2.removeClass("hidden");
        
        } 
        $(window).on("scroll", () => {
            if ($(window).scrollTop() < 300) {
                backToTop2.fadeOut(500, () => {
                    backToTop2.addClass("hidden");
                });
            } else {
                backToTop2.fadeIn(500);
                backToTop2.removeClass("hidden");
            }
        });
        backToTop2.on("click", () => {
            $('html, body').animate({ scrollTop:0 }, '300');
        });

        // WOW JS Initialize
        new WOW().init();
 
        // Sub-Navigation
        $( ".navBlockMobile" ).accordion({ 
            collapsible: true,
            active: false,
            heightStyle: "content"
        });

        $('.sub-nav-mobile-button').click(function (){
            $('.navBlockMobile').toggle('slide', { direction: 'up' });
        });

        // Announcement Bar
        $('.announcementBar').slick({
            arrows: true,
            loop: true,
            adaptiveHeight: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000
        });

        // Home Hero Slider
        $('.snowSlides').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: true,
            dots: true,
            arrows: false,
            infinite: true,
            speed: 700,
            fade: true,
            cssEase: 'linear',
            adaptiveHeight: true,
            centerMode: true
        });

        // Logo Carousel
        $('.logoCarouselSlide').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2000,
            dots:false, 
            arrows:false,
            centerMode: true,
            centerPadding: '30px',
            speed:1300,
            infinite:true
        });

        // Scroll to div
        $("#scrollToLink").click(function() {
            $('html, body').animate({
                scrollTop: $("#scrollToBelow").offset().top
            }, 1000);
        });

        // Scroll To Sticky Menu
        /*function sticktothetop() {
            var window_top = $(window).scrollTop();
            var top = $('.stick-here').offset().top;
            if (window_top > top) {
                $('.stickThis').addClass('stick');
                $('.stick-here').height($('.stickThis').outerHeight());
            } else {
                $('.stickThis').removeClass('stick');
                $('.stick-here').height(0);
            }
        }
        
        $(function () {
            $(window).scroll(sticktothetop);
            sticktothetop();
        });*/

        // Collection Sidebar Show More
      	/*
        $(".tag-list").filter(function () {
            return $(this).find('li').length > 10
             }).append('<li class="showMore">Show More</li>');
         
         $('.tag-list li:nth-child(10)').nextAll('li').hide();
         
         $('.showMore').click(function(){
           $(this).siblings('.tag-list li:nth-child(10)').nextAll('li').slideToggle('slow');
           $(this).text(function(i, text){
                return text === "Show More" ? "Show Less" : "Show More";
            });
         });
         */

        // Image Hover Swap
        $('.logoCarouselSlide .slick-slide div > div').each(function() {
            if ($(this).find('img').length >= 2) {
              $(this).addClass('has-hover');
            }
        });

        // Sub-Navigation
        $('#mobile-sub-navigation-button').click(function (){
            $('.subNavigationMobile').toggle('slide', { direction: 'up' });
        });

        // Hide title if collection logo is there
        if ($('.CollectionSidebarLogo').length > 0 ) {
            $('h1').addClass('hidden');
        }
        
    });

})(jQuery);